import { connect } from "react-redux";
import { State } from "../types";
import BackendErrorDialog from "../components/BackendErrorDialog";

const mapStateToProps = (store: State) => ({
    backendError: store.backendError,
});

export default connect(mapStateToProps)(BackendErrorDialog);
